import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const createBooking = (payload) => api.post("/bookings", payload).then((r) => r.data);
export const getTakenSlots = (date) =>
  api.get(`/bookings/taken`, { params: { date } }).then((r) => r.data.taken || []);
export const createEnquiry = (payload) => api.post("/enquiries", payload).then((r) => r.data);
